"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'placeholder', 'readonly'],
    mixins: [SourceValue_1.default],
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/HiddenInput.vue
// module id = 184
// module chunks = 0